// utils/canAccess.js
export function canAccess(permissions = [], resource, action) {
  const match = permissions.find((perm) => perm.resource === resource);
  if (!match) return false;
  return match.actions.includes(action);
}
